//import $ from 'jquery';
//import moment from 'moment';
import moment from "dayjs";
//import Config from '../../Config';
import Config from "../../app-config";

export const STATES = [
  {
    code: "NSW",
    name: "New South Wales",
  },
  {
    code: "QLD",
    name: "Queensland",
  },
  {
    code: "SA",
    name: "South Australia",
  },
  {
    code: "TAS",
    name: "Tasmania",
  },
  {
    code: "VIC",
    name: "Victoria",
  },
  {
    code: "WA",
    name: "Western Australia",
  },
  {
    code: "NT",
  },
  {
    code: "ACT",
  },
];

export const DAYS = [
  {
    label: "01",
    value: "01",
  },
  {
    label: "02",
    value: "02",
  },
  {
    label: "03",
    value: "03",
  },
  {
    label: "04",
    value: "04",
  },
  {
    label: "05",
    value: "05",
  },
  {
    label: "06",
    value: "06",
  },
  {
    label: "07",
    value: "07",
  },
  {
    label: "08",
    value: "08",
  },
  {
    label: "09",
    value: "09",
  },
  {
    label: "10",
    value: "10",
  },
  {
    label: "11",
    value: "11",
  },
  {
    label: "12",
    value: "12",
  },
  {
    label: "13",
    value: "13",
  },
  {
    label: "14",
    value: "14",
  },
  {
    label: "15",
    value: "15",
  },
  {
    label: "16",
    value: "16",
  },
  {
    label: "17",
    value: "17",
  },
  {
    label: "18",
    value: "18",
  },
  {
    label: "19",
    value: "19",
  },
  {
    label: "20",
    value: "20",
  },
  {
    label: "21",
    value: "21",
  },
  {
    label: "22",
    value: "22",
  },
  {
    label: "23",
    value: "23",
  },
  {
    label: "24",
    value: "24",
  },
  {
    label: "25",
    value: "25",
  },
  {
    label: "26",
    value: "26",
  },
  {
    label: "27",
    value: "27",
  },
  {
    label: "28",
    value: "28",
  },
  {
    label: "29",
    value: "29",
  },
  {
    label: "30",
    value: "30",
  },
  {
    label: "31",
    value: "31",
  },
];

export const MONTHS = [
  {
    label: "01",
    value: "01",
  },
  {
    label: "02",
    value: "02",
  },
  {
    label: "03",
    value: "03",
  },
  {
    label: "04",
    value: "04",
  },
  {
    label: "05",
    value: "05",
  },
  {
    label: "06",
    value: "06",
  },
  {
    label: "07",
    value: "07",
  },
  {
    label: "08",
    value: "08",
  },
  {
    label: "09",
    value: "09",
  },
  {
    label: "10",
    value: "10",
  },
  {
    label: "11",
    value: "11",
  },
  {
    label: "12",
    value: "12",
  },
];

export function getStates() {
  return STATES.sort((a, b) => a.code.localeCompare(b.code));
}

export function detectIE() {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    return true;
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }

  var trident = ua.indexOf("Trident/");
  if (trident > 0) {
    return true;
    // IE 11 => return version number
    var rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }

  var edge = ua.indexOf("Edge/");
  if (edge > 0) {
    return true;
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }

  // other browser
  return false;
}

export function isIOS() {
  var isSafari = !!window.navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  var iOS =
    /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;
  if (isSafari && iOS) {
    return true;
  } else if (isSafari) {
    return false;
  }
}

export function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const formatCurrency = (value, isSymbol) => {
  value = "" + value;
  let newValue = value.replace(/[^0-9\.]+/g, "");
  if (!isSymbol) {
    return Number(newValue);
  } else {
    return "$" + newValue;
  }
};

// export function scrollTop(idErrorElement) {
//   let html = $('html, body');
//   try {
//     if (!idErrorElement) {
//       html.stop().animate({ scrollTop: 0 }, 500);
//     } else {
//       html
//         .stop()
//         .animate(
//           { scrollTop: $('#' + idErrorElement).offset().top - 110 },
//           500
//         );
//     }
//   } catch (err) {}
// }

export function setCurrentTab(tab) {
  localStorage.setItem("CURRENT-TAB", tab);
}

export function getPetAge(pet_dob, startDateValue = "") {
  const today = startDateValue
    ? moment(startDateValue, "YYYY-MM-DD")
    : moment().startOf("day");
  const dob = moment(pet_dob, "DD/MM/YYYY");
  let pet_age = "";
  const years = today.diff(dob, "year");
  const months = today.diff(dob, "month");
  const weeks = today.diff(dob, "week");
  let days = today.diff(dob, "days");
  let count;
  if (years > 0) {
    count = years;
    pet_age = `${years}-year-old`;
  } else if (months >= 3) {
    count = months;
    pet_age = `${months}-month-old`;
  } else if (weeks > 0) {
    count = weeks;
    pet_age = `${weeks}-week-old`;
  }

  pet_age = `${[8, 11].includes(count) ? "an" : "a"} ${pet_age}`;

  return {
    days,
    weeks,
    months,
    pet_age,
    years,
  };
}

export function getDiffDate(days) {
  const minDate = moment("2024-02-06", "YYYY-MM-DD").startOf("day");
  let today = moment().startOf("day");
  today = today.subtract(days, "days");
  if (today.isBefore(minDate)) {
    today = minDate;
  }
  let returnDate = today.format("YYYY-MM-DD");
  return returnDate;
}

export function combineIssueBatchParams(issueBathObj) {
  let issuesParams = {};
  const populateQuotationIds = getPopulateQuotationId();
  issueBathObj.forEach((item, index) => {
    let keyId = item.quotationSyncId || item.quotationId;
    if (item.quotationSyncId) {
      issuesParams[keyId] = {
        quotationSyncId: item.quotationSyncId,
      };
    }

    if (populateQuotationIds && populateQuotationIds[index] !== undefined) {
      const valQuotationId = populateQuotationIds[index];
      console.log(`Populate quotationId: `, valQuotationId);
      issuesParams[valQuotationId] = { quotationId: valQuotationId };
    } else if (item.quotationId) {
      issuesParams[keyId] = { quotationId: item.quotationId };
    }
  });

  localStorage.setItem("KNOSE-ISSUES-DATA", JSON.stringify(issuesParams));
  return issuesParams;
}

export function getIssueBatch() {
  if (localStorage.getItem("KNOSE-ISSUES-DATA")) {
    return JSON.parse(localStorage.getItem("KNOSE-ISSUES-DATA"));
  } else {
    return {};
  }
}

export function storeSalesJourneyId(issuesParams, salesJourneyId, customerId) {
  if (!salesJourneyId) {
    return false;
  }

  localStorage.setItem("KNOSE-customerId", customerId);
  Object.keys(issuesParams).forEach((quotationSyncId) => {
    localStorage.setItem(`KNOSE-SALES-${quotationSyncId}`, salesJourneyId);
  });
}

export function getSalesJourneyId(issuesParams) {
  let salesJourneyId = "";
  Object.keys(issuesParams).forEach((quotationSyncId) => {
    if (localStorage.getItem(`KNOSE-SALES-${quotationSyncId}`)) {
      salesJourneyId = localStorage.getItem(`KNOSE-SALES-${quotationSyncId}`);
    }
  });
  return salesJourneyId;
}

const quotationIdKey = "KNOSE-QUOTATION-ID";
const getPopulateQuotationId = () => {
  if (localStorage.getItem(quotationIdKey)) {
    return JSON.parse(localStorage.getItem(quotationIdKey));
  } else {
    return "";
  }
};

export function removePopulateQuotationId() {
  localStorage.removeItem(quotationIdKey);
  localStorage.setItem("KNOSE-REFRESH-NEW-PRICE", "true");
}

export function setPopulateQuotationId(quotationIds) {
  localStorage.setItem(quotationIdKey, JSON.stringify(quotationIds));
}

export function getIssueObj(policyDetailResponse) {
  const { quotationId, quotationSyncId } = policyDetailResponse;
  let issueBathObj = {};
  if (quotationSyncId) {
    issueBathObj = { quotationSyncId, id: quotationSyncId };
  } else {
    issueBathObj = { quotationId, id: quotationId };
  }
  return issueBathObj;
}

export function isFutureStartDate(pet) {
  const { policy_start_date } = pet;
  const currentDate = moment().startOf("day");
  const petPolicyDate = moment(policy_start_date, "DD/MM/YYYY");
  return currentDate < petPolicyDate;
}

export function getLocationIndex() {
  let getLocation = window.location.pathname;
  switch (getLocation) {
    case "/":
      return 1;
    case "/details":
      return 1;
    case "/quote":
      return 2;
    case "/review":
      return 3;
    case "/payment":
      return 4;
    case "/success":
      return 5;
    case "/email":
      return 6;
    default:
      return false;
  }
}

export function getPolicyRange(pet) {
  const currentDate = moment().startOf("day");
  const minPetYears = currentDate.clone().subtract(9, "years");
  const petBirthDate = pet.pet_dob
    ? moment(pet.pet_dob, "DD/MM/YYYY")
    : currentDate;

  let isOutRangeDay = false;
  let policy_limit_end_date = Config.policy_limit_end_date;
  let startDate = petBirthDate
    .clone()
    .add(Config.policy_limit_start_date * 7, "days");

  const outRangeDays = petBirthDate.diff(minPetYears, "days");
  if (outRangeDays > 0 && outRangeDays < 30) {
    policy_limit_end_date = outRangeDays - 1;
    isOutRangeDay = true;
  }

  if (startDate < currentDate || isOutRangeDay) {
    startDate = currentDate.clone();
  }

  const endDate = currentDate.clone().add(policy_limit_end_date, "days");
  return {
    startDate,
    endDate,
  };
}

export function getPetPaymentInfo(calculatePremium) {
  const { promotionDetail } = calculatePremium;
  let totalPetPolicyFee = calculatePremium.installmentPolicyFeeTotal || 0;
  let totalPetPremium = calculatePremium.installmentBasePremiumPlusGST || 0;
  let totalPetStampDuty = calculatePremium.installmentStampDuty || 0;
  let totalPetPayable = calculatePremium.totalInstallment || 0;
  if (promotionDetail && promotionDetail.promotionType === "Type2") {
    const policyPayments =
      promotionDetail.policyPremiumInstallmentPayments || [];
    if (policyPayments[1] !== undefined) {
      totalPetPremium = policyPayments[1].premium || 0;
      totalPetStampDuty = policyPayments[1].stampDuty || 0;
      totalPetPolicyFee = policyPayments[1].policyFee || 0;
      totalPetPayable = policyPayments[1].totalPayable || 0;
    }
  }

  let totalGST =
    formatCurrency(calculatePremium.installmentPremiumGST || 0) +
    formatCurrency(calculatePremium.installmentPolicyFeeGST || 0);
  totalGST = totalGST > 0 ? totalGST.toFixed(2) : 0;
  const petInfoItem = {
    premium: formatCurrency(totalPetPremium, true),
    premiumGST: formatCurrency(calculatePremium.premiumGST || 0, true),
    stamp: formatCurrency(totalPetStampDuty, true),
    stampDuty: formatCurrency(calculatePremium.stampDuty || 0, true),
    policyFee: formatCurrency(totalPetPolicyFee, true),
    policyFeeGST: formatCurrency(
      calculatePremium.installmentPolicyFeeGST || 0,
      true
    ),
    totalInstallment: formatCurrency(totalPetPayable, true),
    totalPayable: formatCurrency(calculatePremium.totalInstallment, true),
    totalAnnuaYear: formatCurrency(calculatePremium.totalPayable, true),
    totalGST: formatCurrency(totalGST, true),
  };

  return petInfoItem;
}

export function getDiscountInfo(data) {
  const { from, to, totalPayable, discountType, discountRate } = data;
  let isPercent = true;
  let totalDiscount = 0;
  let totalFirstAmount = 0;
  const cntMonths = to - from;
  if (!discountRate) {
    return {
      isPercent,
      cntMonths,
      totalDiscount,
      totalFirstAmount,
    };
  }

  const numberRate = parseFloat(`${discountRate}`.replace(/[^\d\.]*/g, ""), 10);
  if (`${discountType}`.indexOf("Fixed") > -1) {
    isPercent = false;
  }

  totalDiscount = numberRate;
  totalFirstAmount = formatCurrency(totalPayable);

  return {
    isPercent,
    cntMonths,
    totalDiscount,
    totalFirstAmount,
  };
}

export function totalTransactionAmount(pets) {
  if (!pets) return 0;
  let totalAmount = 0;
  let calculateData = [];
  for (let j = 0; j < pets.length; j++) {
    let petData = pets[j];
    let { calculatePremium } = petData;
    calculateData.push(calculatePremium);
    if (calculatePremium.totalInstallment !== undefined) {
      totalAmount += formatCurrency(calculatePremium.totalInstallment);
    }
  }
  return (totalAmount = totalAmount > 0 ? totalAmount.toFixed(2) : 0);
}

export let gtagTrack = {
  quotepage2: function (data) {
    if (!data.totalAmount) return false;
    console.log("Track quotepage2", data);
    window.gtag("event", "conversion", {
      send_to: "AW-837311825/b3AYCOTlrfsBENG6oY8D",
      value: data.totalAmount,
      currency: "AUD",
    });
  },

  paymentSuccessPage: function (data) {
    if (!data.totalAmount || !data.policyNumber) return false;
    console.log("Track paymentSuccessPage", data);
    window.gtag("event", "conversion", {
      send_to: "AW-837311825/lRV_CKjlrfsBENG6oY8D",
      value: data.totalAmount,
      currency: "AUD",
      transaction_id: data.policyNumber,
    });
    this.formCompletion(data);
  },

  emailQuote: function (data) {
    if (!data.totalAmount) return false;
    console.log("Track quotepage email quotre", data);
    window.gtag("event", "conversion", {
      send_to: "AW-837311825/y50iCLTirfsBENG6oY8D",
      value: data.totalAmount,
      currency: "AUD",
    });
  },

  formCompletion: function (data) {
    console.log("Form completion");
    window.gtag("event", "conversion", {
      send_to: "AW-837311825/Fux6CJnSjfsBENG6oY8D",
    });
  },

  phoneClick: function (data) {
    console.log("Phone click");
    this.reportConversion({});
    window.gtag("config", "AW-837311825/ikcvCIntovsBENG6oY8D", {
      phone_conversion_number: "1300 356 642",
    });
  },

  reportConversion: function (data) {
    console.log("Report conversion click");
    window.gtag("event", "conversion", {
      send_to: "AW-837311825/eLhCCNnjrfsBENG6oY8D",
    });
  },

  // onlineChat : function(){
  //   $(document).ready(function(){
  //     let chatBoxSel = $('#fc_frame');
  //     chatBoxSel.click(function() {
  //       window.gtag('event', 'conversion', {'send_to': 'AW-837311825/wAiiCPfTjfsBENG6oY8D'})
  //     });
  //   })

  // }
};

export const klaviyoTrack = {
  quizAnswer: (data) => {
    if (!data.email) return false;
    console.log("Tracking KLAVIYO", data);
    let params = {};
    params["$email"] = data.email;
    if (data.heard_about_us) {
      params["heard_about_us"] = data.heard_about_us;
    } else {
      params["replacing_policy"] = data.replacing_policy || "";
      params["past_vets_clinics"] = data.past_vets_clinics || "";
    }

    window._learnq.push(["identify", params]);
  },
};

export function pushDataToGTM(eventName, quoteData) {
  // window.dataLayer = window.dataLayer || [];

  // console.log("pushDataToGTM - " + eventName, quoteData);

  // try {
  //   window.dataLayer.push({
  //     quoteData: undefined,
  //   });

  //   window.dataLayer.push({
  //     event: eventName,
  //     quoteData,
  //   });
  // } catch (err) {
  //   console.log("pushDataToGTM err", err);
  // }
}

const isTransferPolicy = () => {
  const isTransfer = localStorage.getItem("KNOSE-IS-TRANSFER-POLICY") || "";
  if (isTransfer) {
    return true;
  } else {
    return false;
  }
};

const isPetAgeInfo = (pets) => {
  const today = moment().startOf("day");
  let isLess1YearOld = false;
  let isEquaMore1YearOld = false;
  pets.forEach((pet) => {
    const dob = moment(pet.pet_dob, "DD/MM/YYYY");
    const years = today.diff(dob, "year");
    if (years > 0) {
      isEquaMore1YearOld = true;
    } else {
      isLess1YearOld = true;
    }
  });

  return {
    isLess1YearOld,
    isEquaMore1YearOld,
  };
};

const callApiSaveQuote = async (payload) => {

  try {
    // Loại bỏ field alternateQuotes từ tất cả các pet trong payload
    const cleanedPayload = { ...payload };
    if (cleanedPayload.pets && Array.isArray(cleanedPayload.pets)) {
      cleanedPayload.pets = cleanedPayload.pets.map(pet => {
        if (pet && typeof pet === 'object') {
          const { alternateQuotes, ...petWithoutAlternateQuotes } = pet;
          return petWithoutAlternateQuotes;
        }
        return pet;
      });
    }

    const response = await fetch(`${Config.flow_telemetry_endpoint}?q=save-quote`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cleanedPayload),
    });

    if (!response.ok) {
      console.error('Save Quote API failed', response.statusText);
      return null;
    }

    const data = await response.json();
    console.log('Save Quote API success', data);
    return data;

  } catch (err) {
    console.error('Save Quote request error', err);
    return null;
  }
};

const callApiGetAlternateQuotes = async (quoteNumber, petDetails, minPriceConfigs, maxPriceConfigs, petAgeCategory) => {
  let alternateQuotes = {};

  const pick = (quote) => ({
    premium: quote?.premium?.monthlyPremium,
    vetConsultationFees: 'yes',
    paymentFrequency: "monthly",
    annualBenefitLimit: quote?.benefits?.benefitLimits?.annualBenefitLimit,
    benefitPercentage: quote?.benefits?.benefitLimits?.benefitPercentage,
    annualExcess: quote?.benefits?.benefitLimits?.policyExcess,
    optionalExtras: quote?.benefits?.extrasCover?.behaviouralTreatmentCover ? "yes" : "no"
  });

  const payload = (quoteNumber, priceConfigs) => ({
    data: {
      quoteId: `Q-PETSY-${quoteNumber}`,
      coverLevels: priceConfigs,
      petDetails
    }
  });

  const fetchQuotes = async (body) => {
    const response = await fetch(
      Config.knose_alternate_quotes_api_url,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': Config.knose_alternate_quotes_api_key
        },
        body: JSON.stringify(body)
      }
    );

    if (!response.ok) {
      throw new Error(`PPP-271 API failed: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    let quotes = data.data?.quotes || [];

    if (quotes.length) {
      quotes = quotes.map(quote => ({
        ...quote,
        coverLevels: body.data.coverLevels
      }));
    }

    return quotes;
  };

  try {
    const quotesMin = await fetchQuotes(payload('LOW-PESTY', minPriceConfigs));
    const quotesMax = await fetchQuotes(payload('HIGH-PESTY', maxPriceConfigs));

    // console.log("PPP-274 quotesMin: ", quotesMin);
    // console.log("PPP-274 quotesMax: ", quotesMax);
    let cheapest = null;
    if (quotesMin.length) {
      const sortedQuotes = quotesMin.sort((a, b) =>
        (a.premium?.monthlyPremium || 0) - (b.premium?.monthlyPremium || 0)
      );
      cheapest = sortedQuotes[0];
      // console.log("PPP-271 cheapest: ", cheapest);
    }

    let mostExpensive = null;
    let middleQuote = null;

    let maxAnnualBenefitLimit = 25000;
    let middleAnnualBenefitLimit = 10000;

    if (petAgeCategory && petAgeCategory < 3) {
      maxAnnualBenefitLimit = maxAnnualBenefitLimit + maxAnnualBenefitLimit * 0.2;
      middleAnnualBenefitLimit = middleAnnualBenefitLimit + middleAnnualBenefitLimit * 0.2;
    } else if (petAgeCategory && petAgeCategory >= 3) {
      maxAnnualBenefitLimit = maxAnnualBenefitLimit + maxAnnualBenefitLimit * 0.1;
      middleAnnualBenefitLimit = middleAnnualBenefitLimit + middleAnnualBenefitLimit * 0.1;
    }

    if (quotesMax.length) {
      mostExpensive = quotesMax.find(quote =>
        quote.benefits?.benefitLimits?.annualBenefitLimit === maxAnnualBenefitLimit &&
        quote.benefits?.benefitLimits?.benefitPercentage === 90 &&
        quote.benefits?.benefitLimits?.policyExcess === 150);

      middleQuote = quotesMax.find(quote =>
        quote.benefits?.benefitLimits?.annualBenefitLimit === middleAnnualBenefitLimit &&
        quote.benefits?.benefitLimits?.benefitPercentage === 80 &&
        quote.benefits?.benefitLimits?.policyExcess === 150);

      // const sortedMaxQuotes = quotesMax.sort((a, b) =>
      //   (a.premium?.monthlyPremium || 0) - (b.premium?.monthlyPremium || 0)
      // );
      // mostExpensive = sortedMaxQuotes[sortedMaxQuotes.length - 1];
      // // Tính giá trung bình

      // if (sortedMaxQuotes.length === 1) {
      //   // Nếu chỉ có 1 quote, cả 3 giá đều bằng nhau
      //   middleQuote = mostExpensive;
      // } else if (sortedMaxQuotes.length === 2) {
      //   // Nếu có 2 quotes, giá trung bình là quote thứ 2 (giá cao hơn)
      //   middleQuote = sortedMaxQuotes[1];
      // } else {
      //   // Nếu có nhiều hơn 2 quotes, lấy quote ở giữa
      //   const middleIndex = Math.floor(sortedMaxQuotes.length / 2);
      //   middleQuote = sortedMaxQuotes[middleIndex];
      // }
    }

    // Gán các giá trị vào alternateQuotes
    alternateQuotes.costEffective = cheapest ? pick(cheapest) : null;
    alternateQuotes.balanced = middleQuote ? pick(middleQuote) : null;
    alternateQuotes.topCover = mostExpensive ? pick(mostExpensive) : null;
    // console.log("PPP-271 alternateQuotes Final: ", alternateQuotes);

    // Thêm tất cả quotes
    alternateQuotes.quotes = [
      ...(quotesMin || []),
      ...(quotesMax || []),
    ];
    // console.log("PPP-274 alternateQuotes Final: ", alternateQuotes);

    return alternateQuotes;

  } catch (error) {
    // console.error('PPP-271Error:', error);
    return null;
  }
};



export { getPopulateQuotationId, isTransferPolicy, isPetAgeInfo, callApiSaveQuote, callApiGetAlternateQuotes };
